export default __webpack_public_path__ + "0162cb883c95a35575e04c2f31e57da7.svg";